const saveActionName = 'SaveAction';
const saveActionSelector = `[name="${saveActionName}"]`;
const saveActionBtns = document.querySelectorAll(saveActionSelector);

saveActionBtns.forEach((element, index, parent) => {
  element.addEventListener('click', function (event) {
    let form = event.currentTarget.form;
    let hiddenSave = form.querySelector(`input${saveActionSelector}`);
    if (hiddenSave !== null) {
      hiddenSave.value = element.value;
    } else {
      let hidden = document.createElement('input');
      hidden.name = saveActionName;
      hidden.type = 'hidden'
      hidden.value = element.value;
      form.appendChild(hidden);
    }
  });
});